export default __webpack_public_path__ + "static/media/pow.81952c5d.svg";